import React from 'react';

const ResumeSummary = ({ summary }) => {
  return (
    <section className="mb-8">
      <h3 className="text-lg font-bold text-slate-900 uppercase tracking-wider border-b-2 border-slate-200 pb-2 mb-4 flex items-center gap-2">
        Professional Summary
      </h3>
      <p className="text-slate-700 leading-relaxed text-justify">
        {summary}
      </p>
    </section>
  );
};

export default ResumeSummary;